export default {
  haulers: 'Kuljetusliikkeet',
  setup: 'Asetukset',
  driverExperience: 'Kuljettajan kokemus',
  users: 'Käyttäjät',
};
